import api from './axios';

export const citasService = {
  // Obtener todas las citas - Endpoint correcto con lista de citas
  getAll: () => api.get('/citas/citas/'),
  
  // Obtener citas por fecha
  getByFecha: (fecha) => api.get(`/citas/citas/?fecha=${fecha}`),
  
  // Obtener citas por paciente
  getByPaciente: (rut) => api.get(`/citas/citas/?paciente=${rut}`),
  
  // Crear una nueva cita - utilizando el endpoint específico para la admin
  create: (formData) => {
    // Convertir los datos del formulario al formato que espera el backend
    const backendData = {
      paciente: formData.paciente_rut,
      tratamiento: formData.tipo_tratamiento,
      fecha: formData.fecha,
      hora: formData.hora,
      estado: formData.estado || 'reservada'
    };
    
    // Sprint 4: Planes de sesiones
    if (formData.plan_sesiones_total) {
      backendData.plan_sesiones_total = formData.plan_sesiones_total;
      backendData.plan_sesion_actual = 1;
      backendData.plan_descuento = formData.plan_descuento || null;
    }
    
    return api.post('/citas/crear_cita_admin/', backendData);
  },
  
  // Actualizar una cita - Usar el endpoint específico para admin
  update: (id, formData) => {
    // Convertir los datos del formulario al formato que espera el backend
    const backendData = {
      paciente: formData.paciente_rut,
      fecha: formData.fecha,
      hora: formData.hora,
      estado: formData.estado || 'reservada'
    };
    
    // Enviar el ID del tratamiento si está disponible
    if (formData.tratamiento_id) {
      backendData.tratamiento = formData.tratamiento_id;
    }
    
    return api.put(`/citas/citas/${id}/actualizar/`, backendData);
  },
  
  // Reagendar cita (solo fecha y hora) - Para Drag & Drop
  // Envía únicamente los campos necesarios para evitar sobrescribir otros datos
  patchReschedule: (id, fecha, hora) => {
    return api.patch(`/citas/citas/${id}/actualizar/`, { fecha, hora });
  },
  
  // Eliminar una cita - Usar el endpoint específico con AllowAny permissions
  delete: (id) => api.delete(`/citas/eliminar/${id}/`),
  
  // Obtener horarios disponibles
  getHorariosDisponibles: (fecha) => {
    return api.get(`/citas/disponibles/?fecha=${fecha}`);
  },
  
  // Obtener receta de un tratamiento para pre-cargar en ficha clínica
  getRecetaTratamiento: (tratamientoId) => {
    return api.get(`/citas/tratamientos/${tratamientoId}/receta/`);
  },
  
  // CI-001: Cita Rápida (llamadas telefónicas)
  // Crea paciente + cita en un solo llamado
  createRapida: (data) => {
    return api.post('/citas/rapida/', data);
  },
};
 